<div class="payment-dialog">

    <div class="payment-header">
        <h3 class="dialog-title">
            Total Amount <span class="required">*</span>
        </h3>
    </div>

    <!-- Member Info Card -->
    <div class="member-info">
        <div class="info-row">
            <span class="label">Member ID</span>
            <span class="value">#{{ mem_id }}</span>
        </div>
        <div class="info-row">
            <span class="label">Name</span>
            <span class="value">{{ name }}</span>
        </div>
        <div class="info-row">
            <span class="label">Mobile</span>
            <span class="value">{{ mobile }}</span>
        </div>
    </div>

    <!-- Amount -->
    <mat-form-field appearance="outline" class="amount-field">
        <mat-label>Amount</mat-label>
        <input matInput type="number" [(ngModel)]="totalAmount" readonly />
    </mat-form-field>

    <!-- Pay Button -->
    <button mat-raised-button class="pay-cash-btn" (click)="payCash()">
        <mat-icon>payments</mat-icon>
        PAY CASH
    </button>

</div>